import { EventInput } from "@fullcalendar/core/index.js";
import { Dispatch, SetStateAction } from "react";
import { calculateAge } from "../../../utilis/methods/dateMethods";
import { toUtcZ } from "../../../utilis/methods/localDateTime";

export type TimeSlotType = {
  endTime: string | null;
  timeSlotNo: number;
  startTime: string | null;
  times: string;
  slotType: "dayGridMonth" | "timeGridWeek" | "timeGridDay" | string;
};

export type DoctorsType = {
  doctorId: number;
  doctorName: string;
  color: string;
  duration: string;
  startTime: string;
  endTime: string;
};

export type AllDoctorsType = {
  departmentId: number;
  departmentName: string;
  doctor: SearchParamsDoctorType[];
};

export type DepartmentTypes = {
  departmentId: number;
  departmentCode: string;
  departmentName: string;
  isRefRequired?: boolean;
  skipVitals?: boolean;
  isExternalRef?: boolean;
  clinicId?: number;
  createdById?: number;
  createdByDate?: string;
  deptStatus?: number;
};

export type BookingListType = EventInput;
export type SearchParamsDoctorType = {
  doctorId: number;
  doctorName: string;
  color: string;
  duration: number;
  timeslots: {
    dayId: number;
    startTime: string;
    endTime: string;
  }[];
};
export type BookingParamsType = {
  startTime: string;
  endTime: string;
  department: { departmentId: number; departmentName: string } | null;
  doctor: SearchParamsDoctorType | null;
};

export type SelectedSlotType = {
  slotType:
    | "dayGridMonth"
    | "timeGridWeek"
    | "timeGridDay"
    | "multiMonthYear"
    | string;
} & TimeSlotType;

export type PatientBookingContextType = {
  timeSlot: SelectedSlotType;
  setTimeSlot: Dispatch<SetStateAction<SelectedSlotType>>;
  bookingList: BookingListType[];
  setBookingList: Dispatch<SetStateAction<BookingListType[]>>;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  refetch: boolean;
  setRefetch: Dispatch<SetStateAction<boolean>>;
  editDetails: BookingFormType | null;
  setEditDetails: Dispatch<SetStateAction<BookingFormType | null>>;
  bookingSearchParam: BookingParamsType;
  setBookingSearchParams: Dispatch<SetStateAction<BookingParamsType>>;
  setCopyId: Dispatch<
    SetStateAction<{ departmentId: number | null; doctorId: number | null }>
  >;
  copyId: { departmentId: number | null; doctorId: number | null };
};

export type SlotType = { timeSlotNo?: number; times?: string } | undefined;
export type VisitTypesType = {
  id?: number | undefined;
  visitType?: string | number | undefined;
};

export type BookingFormType = {
  id: string | null;
  patientId: string | null;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  dob: string;
  age: string;
  mobileNumber: string;
  email: string;
  countryCode: {
    country_id: number;
    id: string;
    countryCode: string;
  };
  department?: {
    departmentId: number;
    departmentName: string;
  } | null;
  doctor?: {
    doctorId: number;
    doctorName: string;
    color: string;
  } | null;
  timeSlot?: SlotType | null;
  visitType?: VisitTypesType | null;
  notes?: string;
  startDate?: string | null;
  endDate?: string | null;
  start?: string | null;
  end?: string | null;
  isCompleted: 0 | 1 | 2;
  bookingConfirmed:number;
  isRegistered:number

};

export type SavePayloadType = {
  createdByUserId: number;
  clinicId: number;
  createdDate: string;
  ip: string;
  id: number | string | null;
  patientId: string | null;
  firstName: string;
  lastName: string;
  middleName: string;
  dob: string;
  ageYears: number;
  ageMonths: number;
  ageDays: number;
  gender: string;
  mobile: string;
  email: string;
  departmentId: number;
  doctorId: number;
  appStartTime: string;
  appEndTime: string;
  visitType: number;
  mrn: string;
  status: number;
  tokenNo: number;
  purposeId: number;
  remindSmsDelivry: number;
  notes: string | null;
  timeSlot?: number | null;
  countryId: number | null;
  bookingConfirmed?: number;
  temporaryBooking?:number;
  appointmentBookingDate?:string
  destination?:string
};

export type SaveParamsType = Omit<
  SavePayloadType,
  "clinicId" | "createdByUserId" | "createdDate" | "ip"
>;

export type CalendarObjectType = {
  id: string;
  title: string;
  color: string;
  start: string;
  end: string;
  allDay: boolean;
  data: BookingFormType;
};

export const initialBooking: PatientBookingContextType = {
  timeSlot: {
    slotType: "dayGridMonth",
    endTime: "",
    timeSlotNo: 0,
    startTime: "",
    times: "",
  },
  setTimeSlot: () => {},
  bookingList: [],
  setBookingList: () => {},
  open: false,
  setOpen: () => {},
  refetch: true,
  setRefetch: () => {},
  editDetails: null,
  setEditDetails: () => {},
  setBookingSearchParams: () => {},
  bookingSearchParam: {
    startTime: "",
    endTime: "",
    department: null,
    doctor: null,
  },
  copyId: { departmentId: null, doctorId: null },
  setCopyId: () => {},
};

export type TimeSlotPayloadType = {
  clinicId: number;
  dateSelected: string;
  dayId: number;
  doctorId: number;
};

export type PatientSearchLisType = {
  MobileNo: string;
  lastName: string;
  gender: string;
  patientId: string;
  isVip: number;
  firstName: string;
  dob: string;
  emiratesId: string;
  id: number;
  foDate: string;
  age: string;
  status: number;
};

export type EmergencyContactType = {
  lastName: string;
  contactId: number;
  address2: string;
  address1: string;
  addressType: number;
  mobile: string;
  fullName: string;
  contactTypes: number;
  relationshipId: number;
  contactTypeName: string;
  ecno: number;
  pmasterId: number;
  relationName: string;
  streetAddress: string;
  addressTypeName: string;
};

export type CopayObjectType = {
  deductible: number;
  name: string;
  id: number;
  copay: number;
};

export type InsurancePatientType = {
  insurance: number;
  inPlan_name: string;
  insurancetype_name: string;
  policyNo: string | null;
  insuranceType: number | null;
  cardPhoto2: string;
  cardNo: string;
  cardPhoto: string;
  inGroup_name: string | null;
  createdDate: string;
  policyValidityFrom: string;
  asopNo: string | null;
  id: number;
  insurance_name: string;
  policyValidity: string;
  insuranceGroup: number;
  insurancePlan: number;
};

export type PatientFullDetailsType = {
  image: string | null;
  insurancePatient: InsurancePatientType | null;
  eContactTwo: EmergencyContactType | null;
  companyPatient: string;
  pmaster: {
    lastName: string;
    raceId: number;
    gender: string;
    patientId: string;
    religionId: number;
    languageName: string | null;
    maritalId: number;
    raceName: string | null;
    id: number;
    religionName: string | null;
    gccId: string | null;
    foDate: string;
    patientName: string;
    isEstablished: number;
    maritalName: string;
    languageId: number;
    priority: number;
    grouping: string | null;
    isVip: number;
    firstName: string;
    passportNum: string | null;
    dob: string;
    middleName: string;
    emiratesId: string;
    globalConsent: number;
    a28_msg_status: number;
    age: string;
    paymentMode: number;
    bookingConfirmed:number;
    isRegistered:number;
  };
  patientDetails: {
    encounterId: number | null;
    doctorId: number | null;
    departmentId: number | null;
    pmasterId?: number | null;
    createdDate?: string | null;
    paymentMode?: number | null;
    purposeId?: number | null;
    purposeName?: string | null;
    referBy?: number | null;
    departmentName?: string | null;
    doctorName?: string | null;
    visitType?: number | null;
  };
  eContactOne: EmergencyContactType | "";
  amaster: {
    clinicCountryName: string;
    countryCodeName?: string | null;
    EmiratesID: string;
    address2: null;
    addressType: number;
    address1: string;
    stateId: number;
    clinicCountryId: number;
    mobileNo: string;
    countryId: number;
    conCode: string;
    stateName: string;
    countryCode: number;
    uploadfile: string;
    uploadFlag:boolean;
    patientMasterID: number;
    howKnow: string;
    countryName: string;
    place: string;
    addressMasterID: number;
    email: string;
    photoName: string | null;
  };
  encounter: {
    paymentMode?: number | null;
    encounterId: number | null;
    departmentId: number | null;
    doctorId: number | null;
    pmasterId?: number | null;
    createdDate?: string | null;
    purposeId?: number | null;
    purposeName?: string | null;
    referBy?: number | null;
    departmentName?: string | null;
    doctorName?: string | null;
    visitType?: number | null;
    liscenceNo?: string | null;
    clinicName?: string | null;
    facilityLicenseNo?: number | string | null;
    packageId?: number;
    packageName?: string;
    packageFinalRate?: number | string;
    packageActualRate?: number | string;
    packageCode?: string;
    isLabPackage?: number;
    startTime: string | null;
    endTime: string | null;
    knewAbout?: string;
    referredBy?: string;
    reviewRemarks?: string | null;
    reviewDateTime?: string | null;
  };
  copay: CopayObjectType[];
  postOffice: {
    postofficeId: number;
  };
 
};

type BookingCountrySource = BookingFormType & {
  countryCodeId?: number | null;
  countryDto?: { countryId?: number; conCode?: string } | null;
};

export function buildCountryCodeFromBooking(
  data: Partial<BookingCountrySource>,
): BookingFormType["countryCode"] | null {
  const existingId = Number(data.countryCode?.id || data.countryCode?.country_id || 0);
  if (existingId > 0 && data.countryCode) {
    return {
      ...data.countryCode,
      country_id: data.countryCode.country_id ?? existingId,
      id: data.countryCode.id ?? `${existingId}`,
    };
  }

  const countryCodeId = Number(
    data.countryCodeId ?? data.countryDto?.countryId ?? 0,
  );
  if (!countryCodeId) return null;

  const conCode = data.countryDto?.conCode ?? data.countryCode?.countryCode ?? "";
  return {
    country_id: countryCodeId,
    id: `${countryCodeId}`,
    countryCode: conCode,
  };
}

function resolveCountryId(data: Partial<BookingCountrySource>): number {
  const countryCode = buildCountryCodeFromBooking(data);
  return Number(countryCode?.id || countryCode?.country_id || 0);
}

export const prepareBookingParams = (data: BookingFormType): SaveParamsType => {
  const { fullAge } = calculateAge(data.dob);
  const payload: SaveParamsType = {
    id: parseInt(data.id || "0"),
    firstName: data.firstName,
    middleName: data.middleName,
    lastName: data.lastName,
    gender: data.gender,
    ageDays: fullAge.days,
    ageMonths: fullAge.months,
    ageYears: fullAge.years,
    appStartTime: toUtcZ(data.startDate) ?? "",
    appEndTime: toUtcZ(data.endDate) ?? "",
    departmentId: data.department?.departmentId as number,
    temporaryBooking:0,
    dob: data.dob,
    doctorId: data.doctor?.doctorId as number,
    mobile: data.mobileNumber,
    email: data.email,
    mrn: "",
    notes: data.notes || "",
    patientId: data.patientId || null,
    purposeId: 0,
    remindSmsDelivry: 0,
    status: 1,
    tokenNo: 0,
    visitType: data.visitType?.id as number,
    timeSlot: data?.timeSlot?.timeSlotNo,
    countryId: resolveCountryId(data),
  };
  console.clear();
  console.log("data--------->", data);
  console.log("payload------>", payload);
  return payload;
};